import Component from '@glimmer/component';

interface PrismTableLoadingBodySignature {
  Args: {
    columnCount: number;
    nrOfEmptyRows: number;
    nrOfLoadingRows: number;
  };
}

export default class PrismTableLoadingBody extends Component<PrismTableLoadingBodySignature> {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get nrOfEmptyRows() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return this.numOfTimes(this.args.nrOfEmptyRows);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get nrOfLoadingRows() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return this.numOfTimes(this.args.nrOfLoadingRows);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  numOfTimes(times: number) {
    let noOftimes = times;

    if (Number.isNaN(noOftimes)) {
      noOftimes = 0;
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return new Array(noOftimes);
  }

  <template>
    <tbody class="table-body table-body--loading" role="status">
      {{#each this.nrOfLoadingRows}}
        <tr class="table-row">
          <td class="table-cell" colspan={{@columnCount}}>
            <div class="table-loading-state-bar"></div>
          </td>
        </tr>
      {{/each}}

      {{#each this.nrOfEmptyRows}}
        <tr class="table-row">
          <td class="table-cell" colspan={{@columnCount}}>
          </td>
        </tr>
      {{/each}}
    </tbody>
  </template>
}
